import React from 'react';

const StepContent = props => {
  return <div>{props.children}</div>;
};

export default StepContent;
